<template>
  <form class="lxForm" @submit.prevent>
    <slot />
  </form>
</template>
<script>
export default {
  name: 'LxForm',
  data() {
    return {}
  },
  methods: {
    doSubmit() {
      // this.$emit('submit')
      return false
    },
  },
}
</script>
<style lang="scss" scoped></style>
